import { collection, query, where, getDocs } from 'firebase/firestore';

/**
 * Generate a unique invitation code
 * Format: 6 uppercase alphanumeric characters
 */
export const generateInviteCode = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
};

/**
 * Check if invitation code already exists in Firestore
 */
export const checkInviteCodeExists = async (code, db) => {
  try {
    const usersRef = collection(db, 'users');
    const q = query(usersRef, where('invitationCode', '==', code));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error('Error checking invite code:', error);
    return false;
  }
};

/**
 * Generate a unique invitation code that doesn't exist in database
 */
export const generateUniqueInviteCode = async (db) => {
  let code = generateInviteCode();
  let exists = await checkInviteCodeExists(code, db);
  let attempts = 0;
  const maxAttempts = 10;

  // Try to generate a unique code (max 10 attempts)
  while (exists && attempts < maxAttempts) {
    code = generateInviteCode();
    exists = await checkInviteCodeExists(code, db);
    attempts++;
  }

  if (exists) {
    // If still exists after max attempts, append timestamp
    code = generateInviteCode() + Date.now().toString().slice(-2);
  }

  return code;
};

